import { useEffect, useState } from "react";
import { History, Ban, PauseCircle, PlayCircle, UserCheck, MessageSquareText, UserPlus, Loader2 } from "lucide-react";
import api from "@/lib/api";

const KIND = {
  subscribed: { label: "Iscritto", color: "#10B981", icon: UserCheck },
  created: { label: "Creato", color: "#64748B", icon: UserPlus },
  resubscribed: { label: "Re-iscritto", color: "#10B981", icon: UserCheck },
  unsubscribed: { label: "STOP", color: "#EF4444", icon: Ban },
  reason: { label: "Motivo", color: "#F97316", icon: MessageSquareText },
  paused: { label: "Pausa", color: "#F59E0B", icon: PauseCircle },
  resumed: { label: "Riattivato", color: "#10B981", icon: PlayCircle },
  reactivated: { label: "Fine pausa", color: "#3B82F6", icon: PlayCircle },
  preferred_channel_changed: { label: "Canale preferito", color: "#3B82F6", icon: PlayCircle },
};

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
const who = (b) => (!b || b === "cliente" ? "dal cliente" : b === "sistema" ? "dal sistema" : b === "operatore" ? "dall'operatore" : `dall'operatore ${b}`);

export function ContactStatusHistory({ contactId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!contactId) return;
    setLoading(true);
    api.get(`/contacts/${contactId}/status-history`).then((r) => setData(r.data)).catch(() => setData(null)).finally(() => setLoading(false));
  }, [contactId]);
  if (!contactId) return null;
  return (
    <div className="space-y-2 bg-[#0A0E17] rounded-lg p-3" data-testid="contact-status-history">
      <div className="flex items-center gap-2">
        <History className="h-4 w-4 text-slate-400" />
        <span className="text-xs uppercase tracking-wide text-slate-500 font-medium">Storico stato (iscrizioni, pause, STOP)</span>
      </div>
      {loading ? <Loader2 className="h-4 w-4 animate-spin text-slate-500" /> : !data?.events?.length ? (
        <p className="text-xs text-slate-500">Nessun evento registrato.</p>
      ) : (
        <ol className="space-y-1.5 max-h-44 overflow-y-auto pr-1">
          {data.events.map((e) => {
            const k = KIND[e.event] || KIND.created;
            const Icon = k.icon;
            return (
              <li key={e.id} className="flex items-start gap-2 text-xs" data-testid={`status-event-${e.event}`}>
                <Icon className="h-3.5 w-3.5 mt-0.5 shrink-0" style={{ color: k.color }} />
                <div className="min-w-0">
                  <span className="font-semibold" style={{ color: k.color }}>{k.label}</span>
                  <span className="text-slate-500"> · {fmt(e.ts)} · {who(e.by)}</span>
                  {e.detail && <p className="text-slate-400 truncate" title={e.detail}>{e.detail}</p>}
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
